// MAKA PARIS — Theme JS (The Row style)

// ── BURGER MENU ──
(function() {
  var btn = document.getElementById('burger');
  var menu = document.getElementById('mobileMenu');
  if (!btn || !menu) return;
  btn.addEventListener('click', function() {
    btn.classList.toggle('open');
    menu.classList.toggle('open');
    document.body.style.overflow = menu.classList.contains('open') ? 'hidden' : '';
  });
  menu.querySelectorAll('a').forEach(function(a) {
    a.addEventListener('click', function() {
      btn.classList.remove('open');
      menu.classList.remove('open');
      document.body.style.overflow = '';
    });
  });
})();

// ── GALLERY SWITCH ──
function setMainImg(src, el) {
  var main = document.getElementById('galleryMain');
  if (!main) return;
  main.style.opacity = '0';
  setTimeout(function() {
    main.src = src;
    main.style.opacity = '1';
  }, 150);
  document.querySelectorAll('.gallery-thumb').forEach(function(t) {
    t.classList.remove('active');
  });
  if (el) el.closest('.gallery-thumb').classList.add('active');
}

// ── SIZE SELECTOR ──
(function() {
  document.querySelectorAll('.pd-size').forEach(function(btn) {
    if (btn.classList.contains('unavailable')) return;
    btn.addEventListener('click', function() {
      document.querySelectorAll('.pd-size').forEach(function(b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
      var addBtn = document.getElementById('addToCart');
      if (addBtn) addBtn.dataset.variantId = btn.dataset.variantId;
    });
  });
})();

// ── ADD TO CART ──
(function() {
  var btn = document.getElementById('addToCart');
  if (!btn) return;
  btn.addEventListener('click', function() {
    var id = btn.dataset.variantId;
    if (!id) { alert('Veuillez sélectionner une taille.'); return; }
    var txt = btn.textContent;
    btn.textContent = '...';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function() {
      window.location.href = '/cart';
    }).catch(function() {
      btn.textContent = txt;
      btn.disabled = false;
    });
  });
})();

// ── NAV HIDE ON SCROLL ──
(function() {
  var nav = document.querySelector('nav');
  if (!nav) return;
  var last = 0;
  window.addEventListener('scroll', function() {
    var y = window.scrollY;
    nav.style.transform = (y > 80 && y > last) ? 'translateY(-100%)' : 'translateY(0)';
    nav.style.transition = 'transform .3s ease';
    last = y;
  }, { passive: true });
})();
